import {AgentObjectComponent} from "./component/object-components/agent-object-component/agent-object.component";
import {MvsCrudModeEnum} from "../../core/shared/service/crud/mvs-crud-mode.enum";
import {AgentActivityService} from "./service/api/agent-activity.service";
import {AgentService} from "./service/api/agent.service";
import {AgentActiveObjectService} from "./service/api/agent-active-object.service";
import {AgentNumberService} from "./service/api/agent-number.service";
import {AgentPoolService} from "./service/api/agent-pool.service";
import {CalendarConfigurationService} from "./service/api/calendar-configuration.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";

// am/am.entity-provider.ts
export const AM_ENTITY_SERVICE_PROVIDERS = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['am.AgentActivity', {route: '/am/agents', service: AgentActivityService}],
            ['am.AgentActivityType', {route: '/am/agentActivityTypes'}],

            ['am.Agent', {route: '/am/agents', service: AgentService, objectComponent: [{mode: MvsCrudModeEnum.update, component: AgentObjectComponent}]}],
            ['am.AgentActiveObject', {route: '/am/agentActiveObjects', service: AgentActiveObjectService}],
            ['am.AgentContact', {route: '/am/agentContacts'}],
            ['am.AgentNumber', {route: '/am/agentNumbers', service: AgentNumberService}],
            ['am.AgentPool', {route: '/am/agentPools', service: AgentPoolService}],
            ['am.AgentPoolAgent', {route: '/am/agentPoolAgents'}],
            ['am.AgentPoolContact', {route: '/am/agentPoolContacts'}],
            ['am.CalendarConfiguration', {route: '/am/calendarConfigurations', service: CalendarConfigurationService}],
            ['am.AgentNotificationType', {route: '/am/agentNotificationTypes'}],

            ['am.AgentHolidayCalendar', {route: '/am/agentHolidayCalendars'}],
            ['am.AgentScheduleWeek', {route: '/am/agentScheduleWeeks'}],
            ['am.HolidayCalendar', {route: '/am/holidayCalendars'}],
            ['am.AgentScheduleDay', {route: '/am/agentScheduleDays'}],
            ['am.HolidayCalendarDate', {route: '/am/holidayCalendarDates'}],
            ['am.AgentObjectActivity', {route: '/am/agentObjectActivitys'}]
        ] as EntityServiceEntry[],
        multi: true
    }
];
